import React from "react";
// import { useTranslation } from "react-i18next";

// import usePageMetadata from "@/lib/usePageMetadata";

import HeroSection from "../../features/hero/components/HeroSection";
import DesignSection from "../../features/design/components/DesignSection";
import FeaturesSection from "../../features/features-section/components/FeaturesSection";
import MobileAppSection from "../../features/mobile-app/components/MobileAppSection";
import ReviewsSection from "../../features/reviews/components/ReviewsSection";
import ContactSection from "../../features/contact/components/ContactSection";
import PricingSection from "../../features/pricing/components/PricingSection";
import PricingCalculatorSection from "../../features/pricing-calculator/components/PricingCalculatorSection";
import FaqSection from "../../features/faq/components/FaqSection";

function Home() {
  // const { i18n } = useTranslation();

  // const isArabic = i18n.resolvedLanguage?.startsWith("ar");

  // usePageMetadata(
  //   isArabic
  //     ? "نظام HR | نظام إدارة الموارد البشرية"
  //     : "Home | Nizam HR System",

  //   isArabic
  //     ? "نظام HR هو نظام متكامل لإدارة الموارد البشرية يساعد الشركات على إدارة الموظفين، الحضور والانصراف، الرواتب، التوظيف، وتقييم الأداء بسهولة وكفاءة."
  //     : "Welcome to Nizam HR system — your trusted partner in HR management. Discover our comprehensive solutions designed to streamline your HR processes, enhance employee engagement, and drive organizational success. Explore our services and see how we can transform your HR operations today.",
  // );

  return (
    <div className="relative">
      <HeroSection />
      <DesignSection />
      <FeaturesSection />
      <MobileAppSection />
      <ReviewsSection />
      <ContactSection />
      <PricingSection />
      <PricingCalculatorSection />
      <FaqSection />
    </div>
  );
}

export default Home;